import { getWidgetAccountList } from "api/widgetAPI";
import { useQuery } from "react-query";
import { ProfileAccountInfo } from "api/interfaces/accountInterface.interface";
import { useAppSelector } from "redux/hooks";
import { useMemo } from "react";

import SelectComponent from "components/atoms/select/SelectComponent";
import { LEVEL_TYPE } from "api/interfaces/commonInterface.interface";
import { AccountResult } from "api/interfaces/widgetInterface.interface";
import styled from "styled-components";

interface Props {
  value: string[];
  defaultValue?: string[];
  isDisabled?: boolean;
  onChange?: (value: string[]) => void;
  placeholder?: string;
  id?: string;
}

export default function AccountSelects(props: Props): JSX.Element {
  const selectedAccount: ProfileAccountInfo = useAppSelector(
    (state) => state.accountSettings
  );

  const { data, isFetching } = useQuery(
    ["getWidgetAccountList", selectedAccount.accountId],
    () =>
      getWidgetAccountList({
        accountId: selectedAccount.accountId,
      }),
    {
      enabled: Boolean(selectedAccount.accountId),
    }
  );

  const options = useMemo(() => {
    if (data?.result) {
      const list = data.result.map((res: AccountResult) => {
        return {
          label: res.name,
          value: res.accountId,
        };
      });
      return list;
    }
    return [];
  }, [data]);

  if (selectedAccount.accountLevel === LEVEL_TYPE.EU) {
    return <></>;
  }

  return (
    <AccountSelectWrapper>
      <SelectComponent
        {...props}
        mode="multiple"
        options={options}
        placeholder={"All Organizations"}
        listHeight={300}
        maxTagCount={1}
        className="account-select"
        tagRender={(tag: any) => {
          return (
            <AccountTagEllipsis title={tag?.label}>
              {tag?.label}
            </AccountTagEllipsis>
          );
        }}
        loading={isFetching}
      />
    </AccountSelectWrapper>
  );
}

const AccountTagEllipsis = styled.span`
  display: block;
  max-width: 90px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const AccountSelectWrapper = styled.div`
  min-width: 150px;
  width: 150px;

  .account-select.ant-select-multiple .ant-select-selection-item {
    background: transparent;
    border: none;
    padding-inline: 0;
    margin-inline-end: 4px;
  }

  .account-select.ant-select-multiple .ant-select-selection-item-remove {
    display: none;
  }
`;
